import { lazy, Suspense } from "react";
import { Navigate, Route, Routes } from "react-router-dom";
import Loader from "../components/Loader";


// Global Layouts, Components
const Layout = lazy(() => import("../layout/AppLayout"));
// un protected routes
// const ForgetPassword = lazy(() => import("pages/Auth/ForgetPassword"));
// const ChangePassword = lazy(() => import("pages/Auth/ChangePassword"));

const Login = lazy(() => import("../pages/Auth/Login"));
const Register = lazy(() => import("../pages/Auth/Register"));

const Home = lazy(() => import("../pages/Home"));

const Shop = lazy(() => import("../pages/Shop"));
const Aboutus = lazy(() => import("../pages/Aboutus"));
const Blog = lazy(() => import("../pages/Blog"));
const FAQ = lazy(() => import("../pages/FAQ"));
const ContactUs = lazy(() => import("../pages/ContactUs"));
const Product = lazy(() => import("../pages/ViewProduct"));
const Wishlist = lazy(() => import("../pages/Wishlist"));
const Cart = lazy(() => import("../pages/Cart"));

const Otp = lazy(() => import("../pages/Auth/Otp"));
const ForgotPassword = lazy(() => import("../pages/Auth/ForgotPassword"));

const Profile = lazy(() => import("../pages/Profile"));
const Checkout = lazy(() => import("../pages/Checkout"));
const SubPage = lazy(() => import("../pages/Subpages"));
const CompareProduct = lazy(() => import("../pages/CompareProduct"));

const Test = lazy(() => import("../pages/Test"));
const isAuthenticated = () => {
  return !!localStorage.getItem("token");
};

  const ProtectedRoute = ({ element }: { element: JSX.Element }) => {
    return isAuthenticated() ? element : <Navigate to="/login" />;
};

// const AuthGuard = ({ children }: any) => {
//   const location = useLocation();
//   // Check the authentication status of the user.
//   const isAuthenticated = Cookies.get("sample-access-token");

//   // List of routes that can be accessed without authentication.
//   const unauthenticatedRoutes = [LOGIN_PAGE];
//   if (!isAuthenticated && unauthenticatedRoutes.includes(location.pathname)) {
//     return children;
//   }
//   // Redirect to login page if the user is not authenticated and the route is not in unauthenticated routes.
//   if (!isAuthenticated && !unauthenticatedRoutes.includes(location.pathname)) {
//     return <Navigate to={LOGIN_PAGE} />;
//   }

//   // Redirect to home page if none of the above conditions are met.
//   return <Navigate to={SETUP_DASHBOARD} />;
// };

const routes = [
  {
    path: "",
    element: <Layout />,
    auth: true,
    children: [
      {
        path: "/",
        element: <Home />,
      },
      {
        path: "/shop",
        element: <Shop />,
      },
      {
        path: "/about-us",
        element: <Aboutus />,
      },
      {
        path: "/blog",
        element: <Blog />,
      },
      {
        path: "/faq",
        element: <FAQ />,
      },
      {
        path: "/contact-us",
        element: <ContactUs/>,
      },
      {
        path: "/login",
        element: <Login/>,
      },
      {
        path: "/register",
        element: <Register/>,
      },
      {
        path: "/view-product",
        element: <Product />,
      },
      {
        path: "/otp-verify",
        element: <Otp />,
      },
      {
        path: "/wishlist",
        element: <ProtectedRoute element={<Wishlist />} /> ,
      },
      {
        path: "/cart",
        element:  <ProtectedRoute element={<Cart /> } /> ,
      },
      {
        path: "/forgot-password",
        element: <ForgotPassword />,
      },
      {
        path: "/profile",
        element: <ProtectedRoute element={<Profile /> } />,
      },
      {
        path: "/sub-page",
        element: <SubPage />,
      },
      {
        path: "/compare-list",
        element: <ProtectedRoute element={<CompareProduct />} /> ,
      },
    ],
  },
  { path: "/test", element: <Test /> },
  { path: "/checkout", element: <ProtectedRoute element={<Checkout />} /> },

];

// Component for all the Routes
const AllRoutes = () => {
  return (
    <Suspense fallback={<Loader />}>
      <Routes>
        {routes.map((route: any, index: number) => {
          if (route.children) {
            return (
              <Route key={index} path={route.path} element={route.element}>
                {route.children.map((childRoute: any, childIndex: number) => (
                  <Route
                    key={childIndex}
                    path={childRoute.path}
                    element={childRoute.element}
                  />
                ))}
              </Route>
            );
          } else {
            return (
              <Route key={index} path={route.path} element={route.element} />
            );
          }
        })}
      </Routes>
    </Suspense>
  );
};

export default AllRoutes;
